<template>
   
    <main>
         
        <link rel="stylesheet" :href="baseHref+'css/app.css?v=1'" scope />
        <!--        <link rel="stylesheet" href="../../css/app.css" scope>-->
        <link rel="stylesheet" :href="baseHref+'/css/main.css?v=1'" scope />
        <link rel="stylesheet" :href="baseHref+'css/main-2.css?v=1'" scope />
        <link rel="stylesheet" :href="baseHref+'css/responsive.css?v=1'" scope />
        <!--        <link rel="stylesheet" href="../../css/responsive.css" scope>-->
        <link rel="stylesheet" :href="baseHref+'css/all.css?v=1'" scope />

        <TopHeader />
        <router-view style="min-height:75vh;"></router-view>
        <Foot />
        <vue-progress-bar></vue-progress-bar>
    </main>
</template>
<script>
require("../../public/assets/style/header.css");

import { mapGetters, mapActions } from "vuex";
// import TopHeader from "../snippets/New/Header.vue";
// import Foot from "../snippets/New/Footer.vue";
import TopHeader from "../snippets/New/Header.vue";
import Foot from "../snippets/New/Footer.vue";
// import '../../../public/css/app.css'
// import  '../../../public/css/main.css'
// import  '../../../public/css/main-2.css'
// // import  '../../../public/css/responsive.css'
// import  '../../../public/css/all.css'

export default {
    data() {
        return {
            baseHref:baseHref,
        };
    },
    computed: {
        ...mapGetters("Common", ["Setting"])
    },
    components: {
        TopHeader,
        Foot
    },
    methods: {
        ...mapActions("Common", ["getSettingData"])
    },
    created() { 
        this.getSettingData();
    },
    beforeUpdate() {},
    updated: function() {}
};
</script>
